import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import isEqual from "lodash/isEqual";
import filterTypes from "data/filter-types";
import tagTypes from "data/tag-types";
import findFilterValue from "helpers/find-filter-value";
import getTreesFromMeters, { getMetersFromTrees } from "helpers/get-trees-from-meters";
import {
  festiveDaysAdd,
  festiveDaysSingle,
  festiveDaysTypes,
  festiveDaysUpdate
} from "actions/festive-days/actions";
import { getNoPagination as getNotificationTemplates } from "actions/notificationTemplates/actions";
import { getUsersFilters } from "actions/users/actions";
import { packageGetList } from "actions/package/actions";
import { tariffGetList } from "actions/tariff/actions";
import { getNoPagination } from "actions/tag/actions";
import FilterItem from "views/lib/components/filter/filter-item";
import SearchSelect from "views/lib/components/SearchSelect";
import searchOperationGenerator from "../../../helpers/search-operation-generator";

const existsOptions = [
  {
    label: "Exits",
    value: true
  },
  {
    label: "Not Exist",
    value: false
  },
];

class CreateModal extends Component {
  format = "YYYY-MM-DD";

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);

    this.state = {
      name: "",
      active: true,
      type: "",
      day: 1,
      month: 1,
      minutes: 1,
      notificationTemplateId: null,
      criteria: [],

      filters: {}
    };

    if (!this.props.types.length) {
      this.props.festiveDaysTypes();
    }

    this.props.getUsersFilters();
    this.props.packageGetList();
    this.props.tariffGetList();
    this.props.getTags([{
      fieldName: "type",
      fieldValue: tagTypes.user,
      searchOperation: filterTypes.EQUALS.value
    }]);

    if (this.props.id) {
      this.props.festiveDaysSingle(this.props.id);
    }

    if (!this.props.notificationTemplates.length) {
      this.props.getNotificationTemplates();
    }

    this.validator = new SimpleReactValidator({
      locale: "en",
      element: message => <div className="text-danger">{message}</div>
    });
  }

  componentWillReceiveProps(nextProps) {
    const newStates = {
      ...nextProps.single
    };
    if (!isEqual(nextProps.types, this.props.types)) {
      newStates.type = nextProps.types[0];
    }
    if (nextProps.single && nextProps.single.criteria) {
      newStates.filters = {};
      nextProps.single.criteria.forEach(perFilter => {
        newStates.filters[perFilter.fieldName] = perFilter;
      });
    }
    this.setState(newStates);
  }

  componentWillUnmount() {
    if (this.props.id) {
      this.props.festiveDaysSingle(false);
    }
  }

  handleChange = ev => {
    const toInt = () => {
      if (["day", "month", "minutes"].indexOf(ev.target.name) > -1) {
        let value = parseInt(ev.target.value, 10);
        if (ev.target.name === "day") {
          value = Math.max(1, Math.min(value, 31));
        } else if (ev.target.name === "month") {
          value = Math.max(1, Math.min(value, 12));
        }
        return value;
      }
      return ev.target.value;
    };
    this.setState({
      [ev.target.name]: toInt()
    });
  };

  handleSave = () => {
    if (this.validator.allValid()) {
      const { filters } = this.state;
      const filtersToArray = [];
      Object.keys(filters)
        .forEach(name => {
          if (Object.keys(filters[name]).length) {
            filtersToArray.push(filters[name]);
          }
        });

      const data = Object.assign({}, this.state);
      delete data.filters;
      data.criteria = filtersToArray;
      if (this.props.id) {
        data.id = this.props.id;
        this.props.festiveDaysUpdate(data.id, data, this.props.onCancel);
      } else {
        this.props.festiveDaysAdd(data, this.props.onCancel);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  handleReset = () => {
    this.setState({
      filters: {}
    });
  };

  render() {
    const {
      types,
      packageList,
      tariffList,
      tags,
      usersFilters
    } = this.props;
    const {
      name,
      active,
      type,
      day,
      month,
      minutes,
      notificationTemplateId,

      filters
    } = this.state;

    const notificationTemplatesOptions = this.props.notificationTemplates.map(item => ({
      label: item.name,
      value: item.id,
    }));

    const activeNotificationTemplate = notificationTemplatesOptions.find(item => item.value === notificationTemplateId);

    return (
      <div>
        <h3>Main</h3>
        <div className="row">
          <div className="col-4">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={name}
                onChange={this.handleChange}
              />
              {this.validator.message("name", name, "required")}
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Notification Template</label>
              <SearchSelect
                options={notificationTemplatesOptions}
                isLoading={this.props.notificationTemplatesLoading}
                onChange={val => {
                  this.handleChange({
                    target: {
                      name: "notificationTemplateId",
                      value: val && val.value ? val.value : null
                    }
                  });
                }}
                value={activeNotificationTemplate}
              />
              {this.validator.message("notificationTemplateId", notificationTemplateId, "required")}
            </div>
          </div>
          <div className="col-2">
            <div className="form-group">
              <label>Active</label>
              <select
                className="form-control"
                name="active"
                value={active}
                onChange={this.handleChange}
              >
                <option value={true}>Enabled</option>
                <option value={false}>Disabled</option>
              </select>
            </div>
          </div>
          <div className="col-2">
            <div className="form-group">
              <label>Minutes</label>
              <input
                type="number"
                className="form-control"
                name="minutes"
                value={minutes}
                min={1}
                step={1}
                onChange={this.handleChange}
              />
              {this.validator.message("minutes", minutes, "required")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <label>Type</label>
              <select
                className="form-control"
                name="type"
                value={type || 0}
                onChange={this.handleChange}
              >
                <option value={0}>Select Type</option>
                {types.map(perType => (
                  <option
                    key={perType}
                    value={perType}
                  >
                    {perType}
                  </option>
                ))}
              </select>
              {this.validator.message("type", type || null, "required|string")}
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>Day</label>
              <input
                type="number"
                className="form-control"
                name="day"
                value={day}
                min={1}
                step={1}
                max={31}
                onChange={this.handleChange}
                disabled={type === "BIRTHDAY"}
              />
              {type !== "BIRTHDAY" ? this.validator.message("day", day, "required") : null}
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>Month</label>
              <input
                type="number"
                className="form-control"
                name="month"
                value={month}
                min={1}
                step={1}
                max={12}
                onChange={this.handleChange}
                disabled={type === "BIRTHDAY"}
              />
              {type !== "BIRTHDAY" ? this.validator.message("month", month, "required") : null}
            </div>
          </div>
        </div>

        <h3>
          User Filters
          <button
            className="btn btn-warning btn-sm ml-2"
            onClick={this.handleReset}
          >
            Reset
          </button>
        </h3>
        <div className="row">
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="id"
              placeholder="ID"
              filterType="text"
              defaultValue=""
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(usersFilters.id)}
              value={findFilterValue("id", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="name.first"
              placeholder="First Name"
              filterType="text"
              filterTypeOptions={existsOptions}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(usersFilters["name.first"], [filterTypes.EXIST.value])}
              value={findFilterValue("name.first", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="name.last"
              placeholder="Last Name"
              filterType="text"
              exitsTypeOptions={existsOptions}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(usersFilters["name.last"], [filterTypes.EXIST.value])}
              value={findFilterValue("name.last", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="email"
              placeholder="Email"
              filterType="email"
              exitsTypeOptions={existsOptions}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(usersFilters.email, [filterTypes.EXIST.value])}
              value={findFilterValue("email", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="connected.online"
              placeholder="Connected Online"
              filterType="select"
              filterTypeOptions={[
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                },
              ]}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(usersFilters["connected.online"])}
              value={findFilterValue("connected.online", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="activePackage.name"
              placeholder="Package"
              filterType="select"
              filterTypeOptions={packageList.map(item => ({
                label: item.name,
                value: item.name
              }))}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(usersFilters["activePackage.name"])}
              value={findFilterValue("activePackage.name", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="activeTariff.name"
              placeholder="Tariff"
              filterType="select"
              filterTypeOptions={tariffList.map(item => ({
                label: item.name,
                value: item.name
              }))}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(usersFilters["activeTariff.name"], [filterTypes.EQUALS.value])}
              value={findFilterValue("activeTariff.name", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="tags"
              placeholder="Tags"
              filterType="select_multiple"
              filterTypeOptions={tags.map(value => ({
                label: value.name,
                value: value.name
              }))}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(null, [filterTypes.IN.value])}
              value={findFilterValue("tags", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="sex"
              placeholder="Sex"
              filterType="select"
              filterTypeOptions={[{
                label: "Male",
                value: 0
              }, {
                label: "Female",
                value: 1
              }]}
              exitsTypeOptions={existsOptions}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(null, [filterTypes.EQUALS.value, filterTypes.EXIST.value])}
              value={findFilterValue("sex", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="hasCard"
              placeholder="Has Card"
              filterType="select"
              filterTypeOptions={existsOptions}
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(null, [filterTypes.EQUALS.value])}
              value={findFilterValue("hasCard", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="created"
              placeholder={["Registered From", "To"]}
              filterType="date_range"
              onChange={(name, valueObject) => {
                // eslint-disable-next-line no-prototype-builtins
                if (valueObject && valueObject.hasOwnProperty("fieldValue") && valueObject.searchOperation !== filterTypes.EXIST.value) {
                  const startYear = moment(valueObject.fieldValue[0])
                    .startOf("day")
                    .valueOf();
                  const endYear = moment(valueObject.fieldValue[1])
                    .endOf("day")
                    .valueOf();
                  valueObject = {
                    fieldName: "created",
                    fieldValue: [startYear, endYear],
                    searchOperation: filterTypes.BETWEEN.value,
                  };
                }
                this.handleChangeFilter("created", valueObject);
              }}
              searchOperation={searchOperationGenerator(null, [filterTypes.BETWEEN.value])}
              value={findFilterValue("created", filters)
              && Array.isArray(findFilterValue("created", filters))
                ? findFilterValue("created", filters)
                  .map(d => (d ? moment(d) : null))
                : findFilterValue("created", filters)}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="distance"
              placeholder="Saved Trees"
              filterType="number"
              onChange={(name, valueObject) => {
                // eslint-disable-next-line no-prototype-builtins
                this.handleChangeFilter(name, {
                  ...valueObject,
                  fieldValue: getMetersFromTrees(valueObject.fieldValue) || 0
                });
              }}
              searchOperation={searchOperationGenerator(null, [filterTypes.MORE.value, filterTypes.LESS.value])}
              value={getTreesFromMeters(parseInt(findFilterValue("distance", filters), 10)) || null}
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <FilterItem
              name="lastActionDate"
              placeholder="Last Action"
              filterType="date"
              onChange={this.handleChangeFilter}
              searchOperation={searchOperationGenerator(null, [filterTypes.MORE.value, filterTypes.LESS.value])}
              value={findFilterValue("lastActionDate", filters)}
            />
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <button
            className="btn btn-danger"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSave}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

CreateModal.propTypes = {
  id: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

const mapStateToProps = state => ({
  single: state.festiveDays.single,
  types: state.festiveDays.types,

  usersFilters: state.users.usersFilters,
  packageList: state.package.packageList,
  tariffList: state.tariff.tariffList,
  tags: state.tag.tagListNoPagination,
  notificationTemplates: state.notificationTemplates.list,
  notificationTemplatesLoading: state.notificationTemplates.loading,
});

const mapStateToDispatch = dispatch => ({
  festiveDaysAdd: bindActionCreators(festiveDaysAdd, dispatch),
  festiveDaysUpdate: bindActionCreators(festiveDaysUpdate, dispatch),
  festiveDaysSingle: bindActionCreators(festiveDaysSingle, dispatch),
  festiveDaysTypes: bindActionCreators(festiveDaysTypes, dispatch),

  getUsersFilters: bindActionCreators(getUsersFilters, dispatch),
  packageGetList: bindActionCreators(packageGetList, dispatch),
  tariffGetList: bindActionCreators(tariffGetList, dispatch),
  getTags: bindActionCreators(getNoPagination, dispatch),
  getNotificationTemplates: bindActionCreators(getNotificationTemplates, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(CreateModal);



// WEBPACK FOOTER //
// ./src/views/pages/festiveDays/create-modal.js